import {Component, ElementRef, inject, Input, OnInit, signal, ViewChild} from '@angular/core';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {firstValueFrom, Observable} from 'rxjs';
import {first, map} from 'rxjs/operators';
import {routeAnimations} from "../../../animations/router-animation";
import {MenuOption, MenuService} from "./menu-option";
import {Router} from "@angular/router";
import {MatDrawer} from "@angular/material/sidenav";
import {HelperService} from "../../../../services/helper.service";
import {StorageService} from "../../../../services/storage.service";
import {AuthUserProfile, InstitutionAuthUser, UserTypeEnum} from "../../../../store/entities/uaa/auth-user.model";
import {selectAllAuthUsers} from "../../../../store/entities/uaa/auth-user.selectors";
import {Store} from "@ngrx/store";
import {AppState} from "../../../../store";
import {AuthService} from "../../../../services/auth.service";
import {environment} from "../../../../../environments/environment";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {fadeIn} from "../../../animations/basic-animation";

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
  animations: [
    routeAnimations,
    fadeIn,
    trigger('changeState', [
      state('openState', style({
        minWidth: '190px',
        flexGrow: '1',
      })),
      state('closeState', style({
        width: '0',
        display: 'none',
      })),
      transition('openState <=> closeState', animate('300ms ease-in')),
    ])
  ]
})
export class MainLayoutComponent implements OnInit {

  @Input() from: 'PORTAL' | 'STAFF' = 'STAFF'
  menus: MenuOption[] = []
  menuItems: MenuOption[] = [];
  expandedMenu: string = null
  currentMenu: any;
  @ViewChild('navigationRef') navigationRef: ElementRef;
  activeRouteUrl: string;
  authUser$: Observable<InstitutionAuthUser>
  store = inject(Store<AppState>);
  userType: UserTypeEnum;
  authService = inject(AuthService);
  protected readonly userTypeEnums = UserTypeEnum;
isSidebarExpanded = true;
  private breakpointObserver = inject(BreakpointObserver);
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(
    map(result => result.matches),

  );
contentSize=signal('w-[20%]')

  currentState: 'openState' | 'closeState' = 'openState';

  toggleState() {
    this.currentState = this.currentState === 'openState' ? 'closeState' : 'openState';
  
    this.changeContentSize()
  }
 toggleSidebar() {
    this.isSidebarExpanded = !this.isSidebarExpanded;
  }
  changeContentSize() {
    if (this.currentState === 'closeState') {
        this.contentSize.set('w-[100%]');
    } else {
      
        this.contentSize.set('w-[50%]'); 
    }
    console.log(this.currentState);
}

navigateToLanding() {
  this.toggleSidebar();
  this.router.navigate(['/landing']); 
}

logoutNavigate(){
  this.authService.logout();
}

  constructor(
    private router: Router,
    private helperService: HelperService,
    private storageService: StorageService,
  ) {
    this.userType = this.storageService.get('userType');
  }


  getProfile(userProfile: AuthUserProfile) {
    if (!userProfile?.profilePhoto) return null;
    return environment.SERVER_URL + '/' + userProfile?.profilePhoto;
  }
  menuServices: MenuService = inject(MenuService)

  async ngOnInit(): Promise<void> {
    // this.menus = this.from === 'STAFF' ? menuOptions : await this.filterAndTranslateMenus(portalMenuOptions, this.userType);
    this.menus = await this.menuServices.getMenuOptions();
    let url = this.router.url.split('/').splice(0, 3)


    for (const menu of this.menus) {
      if (menu.route.every((value, index) => value === url[index])) {
        this.setMenus(menu)
        break
      }
    }

    this.authUser$ = this.store.select(selectAllAuthUsers).pipe(first(items => items.length > 0), map(i => i[0]));

  }

  async filterAndTranslateMenus(menus: MenuOption[], userType: UserTypeEnum): Promise<MenuOption[]> {
    const translatedMenus = await Promise.all(
      menus?.map(async menu => {
        if (menu?.menuFor?.includes(userType)) {
          return {
            ...menu,
            name: await firstValueFrom(this.helperService.translateObservable(menu?.name)),
            children: menu?.children ? await this.filterAndTranslateMenus(menu.children, userType) : null,
          };
        }
        return null;
      })
    );
    return translatedMenus.filter(menu => menu !== null);
  }

 

  setMenus(menu: MenuOption) {
  
    this.menuItems = menu?.children;
  }

 

  async logOut() {
    this.authService.logout();
  }
}
